/*
 * Copyright Innov'ATM all rights reserved.
 * This software is the property of Innov'ATM and may not be used in any manner except under a
 * license agreement signed with Innov'ATM.
 */

import { useCallback, useEffect, useRef } from 'react';

// https://github.com/reactjs/rfcs/blob/useevent/text/0000-useevent.md
export const useEvent = <T>(handler: T | undefined | null | false): T => {
    const handlerRef = useRef<T | undefined | null | false>(handler);

    // In a real implementation, this would run before layout effects
    useEffect(() => {
        handlerRef.current = handler;
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useCallback(
        ((...args: any[]) => {
            // In a real implementation, this would throw if called during render
            const fn: any = handlerRef.current;
            return fn?.(...args);
        }) as any,
        [],
    );
};
